__turbopack_context__.v({
  "footerText": "menu-module__f5zpUa__footerText",
  "inactiveButton": "menu-module__f5zpUa__inactiveButton",
  "menuButton": "menu-module__f5zpUa__menuButton",
  "modeButton": "menu-module__f5zpUa__modeButton",
  "modeButtonHighlight": "menu-module__f5zpUa__modeButtonHighlight",
  "modeButtons": "menu-module__f5zpUa__modeButtons",
  "originalModeButton": "menu-module__f5zpUa__originalModeButton",
  "storyModeButton": "menu-module__f5zpUa__storyModeButton",
  "unicodeArrow": "menu-module__f5zpUa__unicodeArrow",
  "unicodeButton": "menu-module__f5zpUa__unicodeButton",
  "unicodeMenu": "menu-module__f5zpUa__unicodeMenu",
});
